import { createSelector } from 'reselect'

const poll_question_selector = questionId => createSelector(
	[ state => state.poll ],
	pollState => {
		const question = pollState.questions.find(question => question.id === questionId)
		const orden = pollState.questions.findIndex(question => question.id === questionId)
		return {
			entityUID: pollState.entityUID,
			presentationId: pollState.presentationId,
			text: question.text,
			serverId: question.serverId,
			icon: question.icon,
			answers: question.answers,
			orden,
		}
	}
)

export default poll_question_selector
